import EditIcon from '@mui/icons-material/Edit'
import React from 'react'
import IconButton from './IconButton'

const EditButton = (props: any) => (
  <IconButton {...props}>
    <EditIcon fontSize='inherit' />
  </IconButton>
)

export default EditButton
